import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import BaseInput from './BaseInput.js';
import Label from './Label.js';
import { ResetIconButton } from './Icons.js';

function Text(_a) {
    var label = _a.label, readOnly = _a.readOnly, disabled = _a.disabled, value = _a.value, validState = _a.validState, onResetIconClick = _a.onResetIconClick, inputRef = _a.inputRef, isFocused = _a.isFocused, props = __rest(_a, ["label", "readOnly", "disabled", "value", "validState", "onResetIconClick", "inputRef", "isFocused"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Label, __assign({ label: label, validState: validState, readOnly: readOnly, disabled: disabled, inputValue: value, isFocused: isFocused }, props)),
        React.createElement(BaseInput, __assign({ labelOfInput: label, validState: validState, readOnly: readOnly, disabled: disabled, value: value, inputRef: inputRef, isFocused: isFocused }, props)),
        value &&
            !disabled &&
            !readOnly &&
            (isFocused || validState === 'error') && (React.createElement(ResetIconButton, { right: "1.6", onClick: function () {
                var _a;
                onResetIconClick();
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            } }))));
}

export { Text as default };
